'use strict';

var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;

var LanguageCollection = require('../../collections/languages').default;

export default Marionette.View.extend({

  className: 'waitlist-no-request-view',
  template: require('./templates/no-request.hbs'),

  initialize: function(options) {
    this.message = options.message ? options.message : polyglot.t('waitlist_confirmation.no_request');
  },

  serializeData: function() {
    return {
      bookLink: this.getBookingLink(),
      emptyMsg: this.message,
    };
  },

  /**
   * Link back to the start of the client view.
   *
   * @returns {string}
   */
  getBookingLink: function () {
    return window.location.pathname + '?lang=' +
      new LanguageCollection(window.LANGUAGES).getCurrent();
  },

  focus: function() {},

});
